module.exports = __webpack_public_path__ + "img/camparisodaoben.01b2acaa.jpg";